<template>
    <validation-observer ref="form" v-slot="{ handleSubmit, errors }">
        <b-form @submit.prevent="handleSubmit(_,save)" class="embedded-page-settings-form">
            <form-inline-bordered-group>
                <template v-slot:left>
                    Properties per page
                </template>
                <template v-slot:right>
                    <validation-provider name="properties_per_page" >
                        <form-select
                            class="no-margin"
                            v-model="values.properties_per_page"
                            :full-width="false"
                            :options="propertiesPerPageOptions"
                            :error="errors.properties_per_page"
                            @change="(newValue) => {
                                save({ properties_per_page: newValue })
                            }"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
            <form-inline-bordered-group>
                <template v-slot:left>
                    Layout
                </template>
                <template v-slot:right>
                    <validation-provider name="layout" >
                        <form-select
                            class="no-margin"
                            v-model="values.layout"
                            :full-width="false"
                            :options="layoutOptions"
                            :error="errors.layout"
                            @change="(newValue) => save({ layout: newValue })"
                        ></form-select>
                    </validation-provider>
                </template>
            </form-inline-bordered-group>
        </b-form>
    </validation-observer>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import { ToggleButton } from 'vue-js-toggle-button';
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormInlineBorderedGroup from '../../generic/form-inline-bordered-group/form-inline-bordered-group.vue';
    import FormSelect from '../../generic/form-select/form-select.vue';
    import { formatResponseError } from '../../../utils/api';

    export default {
        name: 'EmbeddedPageSettingsForm',
        components: {
            ToggleButton,
            FormInput,
            FormInlineBorderedGroup,
            FormSelect,
        },
        props: {
            embeddedPage: Object,
        },
        data() {
            return {
                loading: false,
                values: this.getInitialValues(),
            }
        },
        computed: {
            propertyTitleOptions() {
                return [
                    { value: false, text: 'Property Name' },
                    { value: true, text: 'Marketing Snippet' },
                ]
            },
            propertiesPerPageOptions() {
                return [
                    { value: 0, text: 'No pagination' },
                    { value: 10, text: '10' },
                    { value: 20, text: '20' },
                    { value: 50, text: '50' },
                    { value: 100, text: '100' },
                ]
            },
            layoutOptions() {
                return [
                    { value: 0, text: 'Grid' },
                    { value: 1, text: 'Single column' },
                ]
            }
        },
        methods: {
            getInitialValues() {
                return {
                    search_enabled: this.embeddedPage.search_enabled || false,
                    calendar_enabled: this.embeddedPage.calendar_enabled || false,
                    location_enabled: this.embeddedPage.location_enabled || false,
                    amenities_enabled: this.embeddedPage.amenities_enabled || false,
                    policies_enabled: this.embeddedPage.policies_enabled || false,
                    reviews_enabled: this.embeddedPage.reviews_enabled || false,
                    is_use_marketing_title: this.embeddedPage.is_use_marketing_title || false,
                    contact_us_enabled: this.embeddedPage.contact_us_enabled || false,
                    properties_per_page: this.embeddedPage.properties_per_page || 0,
                    layout: this.embeddedPage.layout || 0,
                }
            },
            async save(additional = {}) {
                this.loading = true;

                try {
                    await this.$store.dispatch('embeddedPage/updateEmbeddedPage', {
                        id: this.embeddedPage.id,
                        ...this.values,
                        ...additional
                    });
                    this.$emit('success');
                } catch (err) {
                    const { generic, fields } = formatResponseError(err);

                    if (generic) {
                        this.errorToast({text: generic})
                    }
                    if (!isEmpty(fields)) {
                        this.$refs.form.setErrors(fields);
                    }
                } finally {
                    this.loading = false;
                }
            }
        },
        watch: {
            embeddedPage() {
                this.values = this.getInitialValues();
            },
        }
    }
</script>

<style scoped>
    .no-margin {
        margin: 0rem !important;
    }

    .embedded-page-settings-form {
        padding: 0 18px;
    }
</style>
